<template>
    <div class="ignore-hover">
        <v-layout row>
            <v-flex xs8 sm9 class="display-1 pr-0 pb-0">{{ profile.batch_control_id }}</v-flex>
            <v-flex xs4 sm3 d-block class="text-right pb-1 pt-0 pl-0">
                <span class="clickable primary-text-hover" @click="$emit('edit')">
                    <span class="fs-14">
                        {{ $t("lang.jig_tag") }}
                    </span>
                    <br />
                    <span class="display-1">
                        {{ profile.jig_tag_number || "---" }}
                    </span>
                </span>
            </v-flex>
        </v-layout>
        <v-data-table
            v-if="receiving_station && receiving_station.length > 0"
            hide-headers
            hide-actions
            :headers-length="5"
            class="border ignore-hover border-bottom-0"
            :items="receiving_station || []"
            :no-data-text="$t('lang.no_data_available')"
            expand
        >
            <template slot="items" slot-scope="props">
                <tr
                    :class="[props.index % 2 == 1 ? 'gray-lightest' : 'no-hover', props.index == receiving_station.length - 1 ? 'border-bottom-2-primary' : '']"
                    class="no-stripe ignore-hover"
                >
                    <td class="px-0 text-center" style="width: 50px">{{ props.index + 1 }}</td>
                    <td class="fw-bold text-uppercase px-1" style="width: 19%">Receiving</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Qty</span><br />{{ props.item.batch_qty || "---" }}</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Received</span><br />{{ props.item.date_received || "---" }}</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">PO</span><br />{{ props.item.po_number || "---" }}</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Lot</span><br />{{ props.item.lot_number || "---" }}</td>
                </tr>
            </template>
        </v-data-table>
        <v-data-table
            v-if="setting_station && setting_station.length > 0 && setting_station[0].date_complete"
            hide-headers
            hide-actions
            :headers-length="6"
            class="border ignore-hover border-bottom-0"
            :items="setting_station || []"
            :no-data-text="$t('lang.no_data_available')"
            expand
        >
            <template slot="items" slot-scope="props">
                <tr :class="receiving_station.length % 2 == 1 ? 'gray-lightest' : 'no-hover'" class="border-bottom-2-primary no-stripe ignore-hover">
                    <td class="px-0 text-center" style="width: 50px">{{ props.index + 1 + receiving_station.length }}</td>
                    <td class="fw-bold text-uppercase px-1" style="width: 19%">Setting</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Date Begin</span><br />{{ props.item.date_begin || "---" }}</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Started By</span><br />{{ props.item.people_started_by || "---" }}</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Date Complete</span><br />{{ props.item.date_complete || "---" }}</td>
                    <td class="px-1" style="width: 19%"><span class="fs-12">Completed By</span><br />{{ props.item.people_completed_by || "---" }}</td>
                </tr>
            </template>
        </v-data-table>
        <v-data-table
            ref="procedures_table"
            v-if="completed_procedures && completed_procedures.length > 0"
            hide-headers
            hide-actions
            :headers-length="6"
            class="border ignore-hover border-top-0"
            :items="completed_procedures || []"
            :no-data-text="$t('lang.no_data_available')"
            expand
            item-key="work_order_procedure_id"
        >
            <template slot="items" slot-scope="props">
                <tr
                    :class="[
                        props.index % 2 == (setting_station.length + (receiving_station.length % 2) == 1 ? 0 : 1) ? 'gray-lightest' : 'no-hover',
                        props.index != completed_procedures.length - 1 && props.item.short_code != completed_procedures[props.index + 1].short_code
                            ? 'group-stations'
                            : '',
                    ]"
                    class="no-stripe ignore-hover"
                >
                    <td class="px-0 text-center" style="width: 50px">{{ props.index + 1 + receiving_station.length + setting_station.length }}</td>
                    <td style="width: 27%" class="fw-bold text-uppercase px-1">{{ props.item.procedure_name }}</td>
                    <td style="width: 20%" class="fw-bold text-uppercase text-center px-1">
                        {{ props.item.short_code ? props.item.short_code : props.item.station }}
                    </td>
                    <td style="width: 24%" class="px-1 text-center">{{ props.item.date_performed }}</td>
                    <td style="width: 24%" class="text-uppercase px-1">{{ props.item.last_updated_by }}</td>
                </tr>
            </template>
            <template slot="expand" slot-scope="props">
                <td v-if="props.item.work_orders_questions" :colspan="6" style="height: auto" class="pl-5 pt-1 pb-3 border-green">
                    <template v-for="(question, index) in props.item.work_orders_questions">
                        <span class="d-block pl-3" :key="index"
                            >{{ question.question }} - <span class="fw-bold">{{ question.answer || "N/A" }}</span></span
                        >
                    </template>
                </td>
            </template>
        </v-data-table>

        <v-card color="grey lighten-4" class="my-3 clickable" v-if="currObjField('has_been_set') == '0'" @click="showWorkOrdersSetting()">
            <v-card-title class="pl-2 py-3 primary white--text" :style="$bp.smAndUp ? 'height:60px' : ''">
                <div>
                    <div class="headline">Setting</div>
                </div>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 sm4 column>
                        <span class="headline">{{ currObjField("name") }}</span>
                        <span class="fs-18">{{ currObjField("batch_control_id") }}</span>
                        <span class="fs-12 pt-2">Begin setting by: {{ currObjField("set_date") }}</span>
                    </v-flex>
                    <v-flex xs12 sm4 column align-self-start :class="$bp.xsOnly ? 'my-2' : 'text-center'">
                        <span class="headline">{{ currObjField("batch_size") }} Qty</span>
                        <span class="fs-16" v-if="currObjField('jig_tag_number')">Jig Tag #: {{ currObjField("jig_tag_number") }}</span>
                    </v-flex>
                    <v-flex xs12 sm4 column text-right align-self-start>
                        <v-layout row>
                            <v-flex order-xs2 order-sm1 :class="$bp.xsOnly ? 'text-left' : 'text-right'">
                                <span class="headline">{{ !!currObjField("setting_station") ? currObjField("setting_station").people_started_by : "" }}</span>
                                <span class="fs-12">{{
                                    !!currObjField("setting_station") ? `Started: ${currObjField("setting_station").date_begin}` : ""
                                }}</span>
                            </v-flex>
                            <v-flex shrink mx-1 order-xs1 order-sm2 style="width: 50px">
                                <v-avatar v-if="!!currObjField('setting_station')">
                                    <img :src="currObjField('setting_station').photo" />
                                </v-avatar>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
        <v-card color="grey lighten-4" class="mb-2 mt-3" v-if="currObjField('has_incomplete_stations') == '1' && currObjField('has_been_set') == '1'">
            <div>
                <v-card-title style="padding-bottom: 10px; padding-top: 12px" :style="$bp.smAndUp ? 'height:60px' : ''" class="primary white--text">
                    <v-layout row wrap :style="$bp.smAndUp ? 'height:60px' : ''">
                        <v-flex class="x6 sm7">
                            <div class="headline cursor-pointer">
                                {{ current_station.station }}
                                {{ current_station && current_station.machine_name ? " - " + current_station.machine_name : null }}
                            </div>
                        </v-flex>
                        <v-flex xs2 sm2 my-auto text-center px-1>
                            {{ current_station.pattern_number }}
                        </v-flex>
                        <v-flex xs2 sm2 my-auto text-center px-1>
                            {{ current_station.minutes_to_complete ? `${current_station.minutes_to_complete} min` : "" }}
                        </v-flex>
                        <v-flex xs2 sm1 v-if="current_station.slug == 'post_wash' || current_station.slug == 'pre_wash' || current_station.slug == 'wash'">
                            <v-icon @click="openWashDialog(current_station.part_station_id)">edit</v-icon>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-divider class="my-0" v-if="current_station.work_orders_procedures"></v-divider>
                <v-card-actions class="pb-0">
                    <v-container fluid pa-0>
                        <v-layout row wrap>
                            <v-flex xs12 pa-2 v-if="current_station.work_orders_procedures">
                                <v-treeview :items="current_station.work_orders_procedures_tree" open-all class="no-arrows" :key="update_tree">
                                    <template slot="prepend" slot-scope="{ item }">
                                        <v-icon v-if="item.icon" :color="item.icon_color">{{ item.icon }}</v-icon>
                                    </template>
                                    <template slot="label" slot-scope="{ item }">
                                        <v-layout row>
                                            <v-flex xs12 pa-0 my-auto d-inline-flex :style="$bp.xsOnly ? 'max-width:200px' : ''">
                                                <div
                                                    v-if="!item.procedure && item.element_rules.includes('required') && !item.procedure_completed"
                                                    :class="{ 'mt-2': $bp.xsOnly }"
                                                    class="red--text"
                                                    style="max-width: 5px; left: -13px; position: relative"
                                                >
                                                    *
                                                </div>
                                                <div
                                                    v-if="$bp.xsOnly"
                                                    class="mt-2"
                                                    :style="
                                                        !item.procedure && item.element_rules.includes('required') && !item.procedure_completed
                                                            ? 'left:-5px;position:relative;'
                                                            : ''
                                                    "
                                                >
                                                    {{ item.name | shrink_text(20)
                                                    }}<span class="fw-bold">{{
                                                        item.question && item.procedure_completed ? (item.answer ? ` - ${item.answer}` : " - N/A") : ""
                                                    }}</span>
                                                </div>
                                                <div
                                                    v-else
                                                    :style="
                                                        !item.procedure && item.element_rules.includes('required') && !item.procedure_completed
                                                            ? 'left:-5px;position:relative;'
                                                            : ''
                                                    "
                                                >
                                                    {{ item.name
                                                    }}<span class="fw-bold">{{
                                                        item.question && item.procedure_completed ? (item.answer ? ` - ${item.answer}` : " - N/A") : ""
                                                    }}</span>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </v-treeview>
                            </v-flex>
                            <v-flex xs12 py-0 px-1>
                                <v-divider class="my-0" v-if="current_station.work_orders_procedures && hasPerm('batch.update')"></v-divider>
                            </v-flex>
                            <v-flex xs12 px-0 pt-1>
                                <v-btn
                                    v-if="hasPerm('batch.update')"
                                    class="mb-2 ml-auto mr-2"
                                    :class="current_station.work_orders_procedures ? 'mt-1' : 'mt-2'"
                                    color="primary"
                                    @mouseup.left="openComplete(current_station, next_procedure)"
                                >
                                    {{ $t("lang.complete_procedure") }}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-actions>
            </div>
        </v-card>
        <span v-if="next_station"
            >{{ $t("lang.next_station") }}: <span class="fw-bold fs-18">{{ next_station.station }}</span></span
        >
        <bc-dialog :value="complete_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ current_station.station }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="complete_dialog"
                        :dialog-status="complete_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part_procedure">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 py-0 v-if="next_procedure">
                                    <span>{{ $t("lang.current_procedure") }}:</span>
                                    <span class="fs-30">{{ next_procedure ? next_procedure.procedure_name : "" }}</span>
                                </v-flex>
                                <v-flex xs12 py-0 v-else-if="current_station.work_orders_procedures">
                                    <v-layout row wrap>
                                        <v-flex v-for="(procedure, index) in current_station.work_orders_procedures" :key="index" xs12 class="py-0 my-0">
                                            <!-- <v-icon color="green">check</v-icon>{{ procedure.procedure_name }} -->
                                            <v-text-field :value="procedure.procedure_name" single-line flat solo readonly class="prevent-click" hide-details>
                                                <template slot="prepend">
                                                    <v-icon color="green">check</v-icon>
                                                </template>
                                            </v-text-field>
                                            <v-divider class="my-0" v-if="index != current_station.work_orders_procedures.length - 1"></v-divider>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex v-if="next_procedure && (next_procedure.work_orders_questions || []).length > 0">
                                    <v-divider></v-divider>
                                    <h3 class="mx-auto">
                                        {{ (next_procedure.work_orders_questions || []).length > 1 ? $t("lang.answer_questions") : $t("lang.answer_question") }}
                                    </h3>
                                    <template v-for="(q, i) in next_procedure.work_orders_questions">
                                        <bc-question-field
                                            :key="i"
                                            v-model="answers[i]"
                                            :label="q.question"
                                            :type="q.element_type"
                                            :set-rules="q.element_rules"
                                            :set-items="q.parts_questions_items"
                                            :setup="complete_dialog"
                                        ></bc-question-field>
                                    </template>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="complete_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="markProcedure(current_station, next_procedure)">{{ $t("lang.complete_procedure") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>

        <bc-dialog :value="work_orders_setting_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.setting") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeWorkOrdersSettingDialog"
                        :dialog-status="work_orders_setting_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="work_orders_setting" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap style="min-height: 350px">
                                <v-flex xs12 sm7 align-self-start pa-0>
                                    <v-layout row wrap inner-layout>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.part_name") }}</span>
                                            <h3>{{ currObjField("name") }}</h3>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.customer_part_number") }}</span>
                                            <h3>{{ currObjField("customer_part_number") }}</h3>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.company") }}</span>
                                            <h3>{{ currObjField("company") }}</h3>
                                        </v-flex>
                                        <v-flex xs12>
                                            <span class="fs-14">{{ $t("lang.control_id") }}</span>
                                            <h3>{{ currObjField("batch_control_id") }}</h3>
                                        </v-flex>
                                        <v-flex xs12 v-if="currObjField('setting_minutes_to_complete')">
                                            <span class="fs-14">{{ $t("lang.estimated_minutes_to_complete") }}</span>
                                            <h3>{{ currObjField("setting_minutes_to_complete") }}</h3>
                                        </v-flex>
                                        <v-flex xs12 sm10 v-if="currObjField('setting_station')">
                                            <v-text-field
                                                v-focus="work_orders_setting_dialog"
                                                v-model="work_orders_setting.jig_tag_number"
                                                :label="`${$t('lang.jig_tag_number')} *`"
                                                :counter="showCounter(work_orders_setting.jig_tag_number, 'work_orders_setting.jig_tag_number')"
                                                :rules="ifValid('work_orders_setting.jig_tag_number')"
                                                type="number"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm5 align-self-start pa-0>
                                    <v-img
                                        :src="currObjField('photo')"
                                        height="175px"
                                        width="175px"
                                        class="rounded-circle"
                                        :class="$bp.smAndUp ? 'mx-auto' : ''"
                                    ></v-img>
                                    <template v-if="currObjField('setting_station')">
                                        <span class="fs-18">{{ $t("lang.destination") }}</span>
                                        <span style="font-size: 100px; max-height: 90px; bottom: 30px; position: relative">{{ currObjField("furnace") }}</span>
                                    </template>
                                </v-flex>
                                <template v-if="currObjField('setting_instructions')">
                                    <v-layout row wrap inner-layout px-2 :class="$bp.xsOnly ? 'pt-3' : ''">
                                        <v-flex xs12 font-italic pb-0>{{ $t("lang.instructions") }}</v-flex>
                                        <v-flex xs12 pt-0 style="max-height: 200px; overflow-y: auto">{{ currObjField("setting_instructions") }}</v-flex>
                                    </v-layout>
                                </template>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeWorkOrdersSettingDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="
                            currObjField('setting_station')
                                ? openNonconformanceAfter()
                                : modifyWorkOrdersSetting('post', currObjField('batch_id'), currSettingStationField('work_order_setting_id'))
                        "
                        >{{ currObjField("setting_station") ? $t("lang.complete") : $t("lang.yes") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>

        <bc-btn-nonconformance ref="nonconformance" entity_object="work_orders_batch" :entity_id="currObjField('batch_id')" no-button></bc-btn-nonconformance>

        <bc-dialog :value="confirm_nonconformance_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.final_check") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="confirm_nonconformance_dialog"
                        :dialog-status="confirm_nonconformance_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <span class="fs-22">Do you need to report a nonconformance for this batch?</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="modifyWorkOrdersSetting('patch', currObjField('batch_id'), currSettingStationField('work_order_setting_id'))">{{
                        $t("lang.no")
                    }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="modifyWorkOrdersSetting('patch', currObjField('batch_id'), currSettingStationField('work_order_setting_id'), true)"
                    >
                        {{ $t("lang.yes") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="wash_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ current_station.station }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close @invoke-method="invokeMethod($event)" dialog-model="wash_dialog" :dialog-status="wash_dialog"></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <bc-autocomplete
                        v-if="current_station.slug == 'pre_wash'"
                        v-model="current_profile.part_station_id"
                        :items="part_stations.pre_wash"
                        item-value="part_station_id"
                        item-text="short_code"
                    >
                    </bc-autocomplete>
                    <bc-autocomplete
                        v-if="current_station.slug == 'post_wash'"
                        v-model="current_profile.part_station_id"
                        :items="part_stations.post_wash"
                        item-value="part_station_id"
                        item-text="short_code"
                    ></bc-autocomplete>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="wash_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="modifyBatch('patch', profile.batch_id)">
                        {{ $t("lang.save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            stations_tree: {},
            remaining_stations: [],
            current_station: {},
            complete_dialog: false,
            answers: [],
            update_tree: 0,
            receiving_station: [],
            setting_station: [],
            work_orders_setting_dialog: false,
            confirm_nonconformance_dialog: false,
            work_orders_setting: {
                batch_id: "",
                jig_tag_number: "",
            },
            wash_dialog: false,
            current_profile: {},
        };
    },
    mounted() {
        this.setGroups();
    },
    watch: {
        $route() {
            // params contains the current route parameters
            this.setGroups();
        },
    },
    computed: {
        ...mapState({
            rules_work_orders_setting: (state) => state.validation.rules_work_orders_setting,
            profile: (state) => state.work_orders.work_orders_batch,
            part_stations: (state) => state.work_orders.part_stations,
        }),
        completed_procedures() {
            let procedures = [];
            let skip = false;
            if (this.completed_stations && this.completed_stations.length > 0) {
                let group_procedures = _.map(this.completed_stations, "work_orders_procedures");
                group_procedures.forEach((g, i) => {
                    if (g) {
                        group_procedures[i] = g.map((obj) => ({
                            ...obj,
                            station: this.completed_stations[i].station,
                            short_code: this.completed_stations[i].short_code,
                        }));
                    } else {
                        skip = true;
                    }
                });
                procedures = _.flatten(group_procedures);

                if (this.$refs.procedures_table) {
                    let expandObject = {};
                    for (const p of procedures) {
                        expandObject[p.work_order_procedure_id] = true;
                    }
                    this.$refs.procedures_table.expanded = expandObject;
                }
            }
            if (skip) procedures = [];
            return procedures;
        },
        next_procedure() {
            return this.current_station && this.current_station.work_orders_procedures
                ? this.current_station.work_orders_procedures.filter((s) => s.date_performed == null)[0] || null
                : null;
        },
        completed_stations() {
            return this.profile && this.profile.work_orders_stations
                ? this.profile.work_orders_stations.filter(
                      ({ work_order_station_id: id1 }) => !this.remaining_stations.some(({ work_order_station_id: id2 }) => id2 === id1)
                  )
                : [];
        },
        next_station() {
            let next = null;
            if (this.remaining_stations && this.remaining_stations.length > 0) {
                if (this.profile && this.profile.has_been_set == "1" && this.remaining_stations.length > 1) {
                    next = this.remaining_stations[1];
                } else if (this.profile && this.profile.has_been_set == "1" && this.remaining_stations.length == 1) {
                    next = null;
                } else {
                    next = this.remaining_stations[0];
                }
            }
            return next;
        },
        currObjField() {
            return (field) => {
                return this.profile && field && this.profile[field] ? this.profile[field] : "";
            };
        },
        currSettingStationField() {
            return (field) => {
                return this.profile && this.profile.setting_station && field && this.profile.setting_station[field] ? this.profile.setting_station[field] : "";
            };
        },
    },
    methods: {
        openComplete() {
            this.complete_dialog = true;
            if (this.next_procedure && (this.next_procedure.work_orders_questions || []).length > 0) {
                this.answers = Array((this.next_procedure.work_orders_questions || []).length).fill("");
            } else {
                this.answers = [];
            }
        },
        markProcedure(station = null, procedure = null) {
            if (station && procedure) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    let body = { work_orders_procedures: [] };
                    let body_procedure = {
                        complete: 1,
                        work_order_procedure_id: procedure.work_order_procedure_id,
                    };
                    if (!procedure.work_orders_questions || this.validateForm("part_procedure")) {
                        // check for questions and only add if they are answered
                        if (procedure.work_orders_questions && this.answers && this.answers.length > 0) {
                            let questions = [];
                            this.answers.forEach((a, i) => {
                                if (a && procedure.work_orders_questions.length > i) {
                                    questions.push({
                                        work_order_question_id: procedure.work_orders_questions[i].work_order_question_id,
                                        answer: a,
                                    });
                                }
                            });
                            if (questions.length > 0) {
                                body_procedure.work_orders_questions = questions;
                            }
                        }
                        body.work_orders_procedures.push(body_procedure);

                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                url: `work_orders/${this.profile.work_order_id}/batches/${station.batch_id}/procedures`,
                                method: "patch",
                                stateProperty: "work_orders_batch",
                                commit: true,
                                body: body,
                            })
                            .then((data) => {
                                if (data) {
                                    this.setGroups();
                                    setTimeout(() => {
                                        this.update_tree++;
                                        this.complete_dialog = false;
                                        if (this.$refs.procedures_table) {
                                            let expandObject = {};
                                            for (const p of this.completed_procedures) {
                                                expandObject[p.work_order_procedure_id] = true;
                                            }
                                            this.$refs.procedures_table.expanded = expandObject;
                                        }
                                    }, 20);
                                    this.$store.commit("validationOff");
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        setGroups() {
            if (this.profile && this.profile.work_orders_stations) {
                this.stations_tree = {};
                let stations_tree = [...this.profile.work_orders_stations];
                stations_tree.forEach((v, i) => {
                    if (v.work_orders_procedures) {
                        stations_tree[i].work_orders_procedures_tree = [];
                        v.work_orders_procedures.forEach((procedure, ii) => {
                            let procedure_tree = {
                                id: procedure.part_procedure_id,
                                name: procedure.procedure_name,
                                procedure: 1,
                                part_station_id: procedure.part_station_id,
                                part_procedure_id: procedure.part_procedure_id,
                                icon: !!procedure.date_performed ? "check" : "close",
                                icon_color: !!procedure.date_performed ? "green" : "red",
                            };
                            if (procedure.work_orders_questions) {
                                let questions_tree = [];
                                procedure.work_orders_questions.forEach((question) => {
                                    questions_tree.push({
                                        id: question.part_question_id,
                                        name: question.question,
                                        question: 1,
                                        part_question_id: question.part_question_id,
                                        part_procedure_id: question.part_procedure_id,
                                        element_rules: question.element_rules,
                                        answer: question.answer,
                                        part_station_id: procedure.part_station_id,
                                        procedure_completed: !!procedure.date_performed,
                                    });
                                });
                                procedure_tree["children"] = questions_tree;
                            }
                            stations_tree[i].work_orders_procedures_tree.push(procedure_tree);
                        });
                    }
                });
                this.stations_tree = stations_tree;

                // set next station if a station has no date performed
                if (this.profile && this.profile.work_orders_stations) {
                    this.remaining_stations = this.profile.work_orders_stations.filter((s) => s.date_performed == null);
                    if (this.remaining_stations.length > 0) this.current_station = this.remaining_stations[0];
                }
                // this.grouped_stations = _.groupBy(stations_tree, 'sort_order');
            }

            if (this.profile && this.profile.work_orders_batch_details) {
                this.receiving_station = this.profile.work_orders_batch_details;
            }

            if (this.profile && this.profile.setting_station) {
                this.setting_station = [];
                this.setting_station.push(this.profile.setting_station);
            }
        },
        showWorkOrdersSetting() {
            let item = this.profile && this.profile.setting_station ? this.profile.setting_station : null;
            if (this.$refs.work_orders_setting) item ? this.$refs.work_orders_setting.resetValidation() : this.$refs.work_orders_setting.reset();

            this.$nextTick(() => {
                this.assignObj(this.work_orders_setting, item, this.rules_work_orders_setting);

                if (this.currObjField("jig_tag_number")) this.work_orders_setting.jig_tag_number = this.currObjField("jig_tag_number");
                this.work_orders_setting_dialog = true;
            });
        },
        modifyWorkOrdersSetting(method = null, batch_id = null, setting_id = null, start_nonconformance = false) {
            if (method) {
                this.confirm_nonconformance_dialog = false;
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("work_orders_setting")) {
                        this.$store.commit("toggleModalLoader", true);
                        let batch_id_body = {
                            batch_id: batch_id,
                        };
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "batch_id",
                                id: batch_id,
                                url: `work_orders/${this.currObjField("work_order_id")}/setting/${setting_id ? setting_id : ""}`,
                                method: method,
                                stateProperty: "work_orders_batch",
                                commit: true,
                                body: method == "patch" ? this.work_orders_setting : batch_id_body,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.work_orders_setting_dialog = false;
                                    if (start_nonconformance) {
                                        this.$refs.nonconformance.showNonconformance();
                                    }
                                    this.setGroups();
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        openNonconformanceAfter() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("work_orders_setting")) {
                    this.confirm_nonconformance_dialog = true;
                }
            });
        },
        closeWorkOrdersSettingDialog() {
            this.work_orders_setting_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        openWashDialog(station_id) {
            this.wash_dialog = true;
            this.current_profile = { part_station_id: station_id };
        },
        modifyBatch(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchWorkOrder", {
                            pk: "batch_id",
                            id: id,
                            url: `work_orders/${this.currObjField("work_order_id")}/batches/${id ? id : ""}/station/${
                                this.current_station.work_order_station_id
                            }`,
                            method: method,
                            stateProperty: "work_orders_batch",

                            commit: true,
                            body: this.current_profile,
                        })
                        .then((data) => {
                            if (data && data.code == "200") {
                                this.wash_dialog = false;
                                this.setGroups();
                            }
                            this.$store.commit("toggleModalLoader", false);
                        });
                });
            }
        },
    },
};
</script>
